import React, { ImgHTMLAttributes } from 'react';
import Illustrations, { TIllustration } from './Illustrations';
import Image from '../Common/Image';
import { MUIStyledCommonProps } from '@mui/system';
import { Theme } from '@mui/material';

type BaseImagePropsWithMuiStyledProps = ImgHTMLAttributes<HTMLImageElement> &
  MUIStyledCommonProps<Theme> & {
    illustrationName?: TIllustration;
  };

const Illustration: React.FC<
  React.PropsWithChildren<BaseImagePropsWithMuiStyledProps>
> = ({ illustrationName, ...rest }) => {
  if (!illustrationName) {
    return null;
  }

  const IllustrationSrc = Illustrations[illustrationName];

  if (!IllustrationSrc) {
    return null;
  }

  return <Image src={IllustrationSrc} {...rest} />;
};

export default Illustration;
